__turbopack_context__.v({
  "Content": "FeatureProject-module-sass-module__Js2q5W__Content",
  "ContentInner": "FeatureProject-module-sass-module__Js2q5W__ContentInner",
  "FeatureProject": "FeatureProject-module-sass-module__Js2q5W__FeatureProject",
  "Image": "FeatureProject-module-sass-module__Js2q5W__Image",
  "Main": "FeatureProject-module-sass-module__Js2q5W__Main",
  "ProjectDetails": "FeatureProject-module-sass-module__Js2q5W__ProjectDetails",
  "Quote": "FeatureProject-module-sass-module__Js2q5W__Quote",
  "ViewWork": "FeatureProject-module-sass-module__Js2q5W__ViewWork",
});
